import { localStorageProvider } from "../AppController";

/**
 * Hook to detect Android WebView and initialize Android authentication
 * This hook runs on app load and automatically authenticates the user
 * if running in an Android WebView with valid authentication
 */
export const useAndroidAuth = () => {
  // Check if running in Android WebView synchronously during render
  if (typeof window !== "undefined" && window.AndroidAuth) {
    try {
      const isAuthenticated = window.AndroidAuth.isAuthenticated();
      const token = isAuthenticated ? window.AndroidAuth.getAuthToken() : null;

      if (token && isAuthenticated) {
        // Store the token for API calls
        localStorageProvider.set("idToken", token);
        localStorageProvider.set("android", "true");

        // Redirect from login page if currently on login
        const currentPath = window.location.hash || window.location.pathname;
        if (
          currentPath.includes("/login") ||
          currentPath === "/" ||
          currentPath === ""
        ) {
          // Let the router handle the redirect based on auth state
          // Don't force redirect here to avoid conflicts with React Router
        }
      } else {
        // Clear Android auth flag if not authenticated
        localStorageProvider.remove("android");
        localStorageProvider.remove("idToken");
      }
    } catch (error) {
      console.error("❌ Error getting Android auth token:", error);
      localStorageProvider.remove("android");
      localStorageProvider.remove("idToken");
    }
  }
};
